/* eslint-disable */
import React, {Fragment, useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom';
import Layout from "../../component/Layout"
import "./result.styles.css"
import {loadState} from '../../_helpers'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import SuccessImage from '../../assets/success.png'
import PendingImage from '../../assets/pending.png'

const Result = () => {
    let navigate = useNavigate();
    const [state, setState] = useState({});
    const [buttonPath, setButtonPath] = useState({})
    let query = new Map(window.location.href.substring(1).split("?")[1].split("&").map(el => el.split("=")))

    let data = {
        dataSukses: {
            title: "Transaksi Sukses",
            result: [{
                img: SuccessImage,
                title: "Terima Kasih",
                message: "",
                description: " Transaksi Anda berhasil. Anda bisa melihat bukti transaksi atau kembali ke halaman utama.",
                buttonTitle1: "Lihat Transaksi",
                buttonTitle2: "Halaman Utama",
            }]
        },
        dataPending: {
            title: "Transaksi Pending",
            result: [{
                img: PendingImage,
                title: "Terima Kasih",
                message: "Transaksi anda Pending",
                description: " Transaksi Anda pending. Anda bisa kembali ke keranjang untuk mencoba lagi atau kembali ke halaman utama.",
                buttonTitle1: "Keranjang",
                buttonTitle2: "Halaman Utama",
            }]
        },
        dataGagal: {
            title: "Transaksi Gagal",
            result: [{
                img: PendingImage,
                title: "Terjadi Kesalahan",
                message: query.get('transaction_status').replace(/%20/g, ' '),
                description: " Transaksi Anda gagal. Anda bisa kembali ke keranjang atau kembali ke halaman utama.",
                buttonTitle1: "Keranjang",
                buttonTitle2: "Halaman Utama",
            }]
        }
    }
    const onExit = () =>{
        navigate("/exit")
        localStorage.clear();
    }

    useEffect(() => {
        setButtonPath({
            home: `/home?cardNumber=${loadState('cardNumber')}&sessionId=${loadState('sessionId')}&memberId=${loadState('memberId')}&memberName=${loadState('memberName')}&memberType=${loadState('memberType')}&memberGroup=${loadState('memberGroup')}&tableNo=${loadState('tableNo')}`,
            transaction: `/transaction?memberId=${loadState('memberId')}&memberType=${loadState('memberType')}&memberGroup=${loadState('memberGroup')}`
        })

        switch (query.get('status_code')) {
            case "200":
                return setState(data.dataSukses)
            case "201":
                return setState(data.dataPending)
            case "400":
                return setState(data.dataGagal)
            default:
                break;
        }
    }, [])

    const routePath = () => {
        switch (query.get('status_code')) {
            case "200":
                return buttonPath.transaction
            case "201":
                return '/payment'
            case "400":
                return '/payment'
            default:
                break;
        }
    }

    return (
        <Layout>
            <nav className="single-navbar-result background-pink py-1" role="navigation" aria-label="main navigation">
                <div className="has-text-centered">
                    <strong className="title-nav-result is-size-5 has-text-white">
                        {state.title}
                    </strong>
                    <FontAwesomeIcon className='icon-exit' icon={faTimesCircle} onClick={() => onExit()}/>
                </div>
            </nav>

            <div className="result-page">
                {state.result && state.result.map((r, i) => (
                    <Fragment key={i}>
                        <div className="result-body">
                            <img src={r.img} alt="img"/>
                            <p className="result-title">
                                {r.title}
                                <br/>
                                {r.message}
                            </p>
                            <p className="result-description">
                                {r.description}
                            </p>
                        </div>
                        <div className="result-footer">
                            <button
                                onClick={() => navigate(routePath())}>
                                {r.buttonTitle1}
                            </button>
                            <button onClick={() => navigate(buttonPath.home)}>
                                {r.buttonTitle2}
                            </button>
                        </div>
                    </Fragment>
                ))}
            </div>
        </Layout>
    )
}

export default Result
